import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Clientes } from "../../Clientes/Clientes";
import { Personal } from "../../Personal/Personal";
import { Productos } from "../../Productos/Productos";
import { VisitasATiendas } from "../../Rutas/VisitasATiendas/VisitasATiendas";
import { ServiciosConfiguracion } from "../../Servicios/ServiciosConfiguracion/ServiciosConfiguracion";
import { Tiendas } from "../../Tiendas/Tiendas";
import { DatosServiciosAutorizacionFilters } from "../DatosServiciosAutorizacionFilters/DatosServiciosAutorizacionFilters";
import { DatosServiciosAutorizacionReportesAppSupervisorFilters } from "../DatosServiciosAutorizacionReportesAppSupervisorFilters/DatosServiciosAutorizacionReportesAppSupervisorFilters";
import { DatosServiciosAutorizacionReportesFilters } from "../DatosServiciosAutorizacionReportesFilters/DatosServiciosAutorizacionReportesFilters";
import { ACTAgregarReporte } from "./ACTAgregarReporte";
import { ACTAutorizarReporte } from "./ACTAutorizarReporte";
import { ACTCheckin } from "./ACTCheckin";
import { ACTCheckout } from "./ACTCheckout";
import { ACTVerUbicacion } from "./ACTVerUbicacion";
import { GestionReportesViewColumnsOverrides } from "./GestionReportesViewColumnsOverrides";

const columns = () =>
(
    {
        c_visita_id: new EntityColumn<string>({ name: 'c_visita_id', type: 'char', length: 20, flags: c.PKAutonum | EntityColumnFlags.nullable, prompt: 'Visita Id' }),
        c_datos_servicio_id: new EntityColumn<string>({ name: 'c_datos_servicio_id', type: 'char', length: 20, flags: c.FK, prompt: 'Datos Servicio Id' }),
        c_datos_servicio_registro_id: new EntityColumn<string>({ name: 'c_datos_servicio_registro_id', type: 'char', length: 20, flags: c.FK, prompt: 'Datos Servicio Registro Id' }),
        c_servicio_id: new EntityColumn<string>({ name: 'c_servicio_id', type: 'char', length: 20, flags: c.FK, prompt: 'Servicio Id' }),
        c_paso_id: new EntityColumn<string>({ name: 'c_paso_id', type: 'char', length: 20, flags: c.FK, prompt: 'Paso Id' }),
        c_tienda_id: new EntityColumn<string>({ name: 'c_tienda_id', type: 'char', length: 20, flags: c.FK, prompt: 'Tienda Id' }),
        c_producto_id: new EntityColumn<string>({ name: 'c_producto_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Producto Id' }),
        c_cliente_id: new EntityColumn<string>({ name: 'c_cliente_id', type: 'char', length: 20, flags: c.FK, prompt: 'Cliente Id' }),
        c_personal_id: new EntityColumn<string>({ name: 'c_personal_id', type: 'char', length: 20, flags: c.FK, prompt: 'Personal Id' }),
        c_relevamiento_status_id: new EntityColumn<string>({ name: 'c_relevamiento_status_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Relevamiento Status Id' }),
        c_autorizacion_directa_status_id: new EntityColumn<string>({ name: 'c_autorizacion_directa_status_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Autorizacion Directa Status Id' }),
        dt_fecha_hora_realizado: new EntityColumn<Date>({ name: 'dt_fecha_hora_realizado', type: 'datetime', flags: c.Edit, prompt: 'Fecha Hora Realizado' }),
        vc_clientes: new EntityColumn<string>({ name: 'vc_clientes', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Clientes' }),
        vc_productos: new EntityColumn<string>({ name: 'vc_productos', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Productos' }),
        vc_servicios: new EntityColumn<string>({ name: 'vc_servicios', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Servicios' }),
        vc_imagenes: new EntityColumn<string>({ name: 'vc_imagenes', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Imágenes' }),
        vc_imagenes_observaciones: new EntityColumn<string>({ name: 'vc_imagenes_observaciones', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Imágenes Observaciones' }),
        c_persona_id: new EntityColumn<string>({ name: 'c_persona_id', type: 'char', length: 20, flags: c.FK, prompt: 'Persona Id' }),
        vc_numerodni: new EntityColumn<string>({ name: 'vc_numerodni', type: 'varchar', length: 255, flags: c.Edit, prompt: 'DNI' }),
        vc_nombre: new EntityColumn<string>({ name: 'vc_nombre', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre' }),
        vc_apellido: new EntityColumn<string>({ name: 'vc_apellido', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Apellido' }),
        vc_puestotrabajo: new EntityColumn<string>({ name: 'vc_puestotrabajo', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Puesto' }),
        dt_nacimiento: new EntityColumn<Date>({ name: 'dt_nacimiento', type: 'date', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Nacimiento' }),
        vc_genero: new EntityColumn<string>({ name: 'vc_genero', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Género' }),
        vc_fotoguid: new EntityColumn<string>({ name: 'vc_fotoguid', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Foto URL' }),
        vc_superior: new EntityColumn<string>({ name: 'vc_superior', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Superior' }),
        vc_telefono: new EntityColumn<string>({ name: 'vc_telefono', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Teléfono' }),
        vc_celular: new EntityColumn<string>({ name: 'vc_celular', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Celular' }),
        vc_celular_trabajo: new EntityColumn<string>({ name: 'vc_celular_trabajo', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Celular Trabajo' }),
        vc_telefono_alternativo: new EntityColumn<string>({ name: 'vc_telefono_alternativo', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Teléfono Alternativo' }),
        vc_email: new EntityColumn<string>({ name: 'vc_email', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Email' }),
        vc_email_alternativo: new EntityColumn<string>({ name: 'vc_email_alternativo', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Email Alternativo' }),
        f_latitud: new EntityColumn<number>({ name: 'f_latitud', type: 'float', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Latitud' }),
        f_longitud: new EntityColumn<number>({ name: 'f_longitud', type: 'float', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Longitud' }),
        vc_domicilio_completo: new EntityColumn<string>({ name: 'vc_domicilio_completo', type: 'varchar', length: 2048, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Domicilio Completo' }),
        n_total_horas_semanales: new EntityColumn<number>({ name: 'n_total_horas_semanales', type: 'decimal', scale: 2, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Total Horas Semanales' }),
        n_horas_semanales_disponibles: new EntityColumn<number>({ name: 'n_horas_semanales_disponibles', type: 'decimal', scale: 2, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Horas Semanales Disponibles' }),
        n_horas_semanales_compartidas: new EntityColumn<number>({ name: 'n_horas_semanales_compartidas', type: 'decimal', scale: 2, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Horas Semanales Compartidas' }),
        n_horas_semanales_exclusivas: new EntityColumn<number>({ name: 'n_horas_semanales_exclusivas', type: 'decimal', scale: 2, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Horas Semanales Exclusivas' }),
        dt_fecha_baja: new EntityColumn<Date>({ name: 'dt_fecha_baja', type: 'date', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fecha Baja' }),
        dt_fecha_alta: new EntityColumn<Date>({ name: 'dt_fecha_alta', type: 'date', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fecha Alta' }),
        dt_licencia_desde: new EntityColumn<Date>({ name: 'dt_licencia_desde', type: 'date', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Licencia Desde' }),
        dt_licencia_hasta: new EntityColumn<Date>({ name: 'dt_licencia_hasta', type: 'date', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Licencia Hasta' }),
        c_estado_licencia_id: new EntityColumn<string>({ name: 'c_estado_licencia_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Estado Licencia Id' }),
        vc_nombre_tienda: new EntityColumn<string>({ name: 'vc_nombre_tienda', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre' }),
        bt_checkin: new EntityColumn<boolean>({ name: 'bt_checkin', type: 'bit', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Checkin' }),
        bt_checkout: new EntityColumn<boolean>({ name: 'bt_checkout', type: 'bit', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Checkout' }),
        d_fecha_visita: new EntityColumn<Date>({ name: 'd_fecha_visita', type: 'date', flags: c.Edit, prompt: 'Fecha Visita' }),
        t_hora_desde: new EntityColumn<string>({ name: 't_hora_desde', type: 'time', flags: c.Edit, prompt: 'Hora Desde' }),
        t_hora_hasta: new EntityColumn<string>({ name: 't_hora_hasta', type: 'time', flags: c.Edit, prompt: 'Hora Hasta' }),
        vc_observaciones_visita: new EntityColumn<string>({ name: 'vc_observaciones_visita', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Observaciones Visita' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        dasa_brwStandard: { name: 'dasa_brwStandard', keyMappings: { c_datos_servicio_id: 0 } },
        dasa_brwAutorizacion: {
            name: 'dasa_brwAutorizacion'
            , keyMappings: { c_datos_servicio_id: 1 }
            , FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new DatosServiciosAutorizacionFilters(client, parentKeys)
        },
        dasa_brwAutorizacionProductos: { name: 'dasa_brwAutorizacionProductos', keyMappings: { c_datos_servicio_id: 0 } },
        dasa_brwAutorizacionPorPersonal: { name: 'dasa_brwAutorizacionPorPersonal', keyMappings: { c_datos_servicio_id: 0 } },
        dasa_brwAutorizacionPorTienda: { name: 'dasa_brwAutorizacionPorTienda', keyMappings: { c_datos_servicio_id: 0 } },
        dasa_brwAutorizacionCliente: {
            name: 'dasa_brwAutorizacionCliente'
            , keyMappings: { c_visita_id: 0 }
            , FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new DatosServiciosAutorizacionFilters(client, parentKeys)
        },
        dasa_brwGestionReportes: {
            name: 'dasa_brwGestionReportes'
            , keyMappings: { c_visita_id: 11 }
            , gridColumnsOverrides: GestionReportesViewColumnsOverrides
            , FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new DatosServiciosAutorizacionReportesFilters(client, parentKeys)
        },
        dasa_brwGestionReportesVisitasIniciadas: {
            name: 'dasa_brwGestionReportesVisitasIniciadas'
            , keyMappings: { c_visita_id: 12, c_personal_id: 13 }
            , gridColumnsOverrides: GestionReportesViewColumnsOverrides
            , FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new DatosServiciosAutorizacionReportesFilters(client, parentKeys)
        },
        dasa_brwGestionReportesVisitasEnProceso: {
            name: 'dasa_brwGestionReportesVisitasEnProceso'
            , keyMappings: { c_visita_id: 12, c_personal_id: 13 }
            , gridColumnsOverrides: GestionReportesViewColumnsOverrides
            , FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new DatosServiciosAutorizacionReportesFilters(client, parentKeys)
        },
        dasa_brwGestionReportesVisitasFinalizadas: {
            name: 'dasa_brwGestionReportesVisitasFinalizadas'
            , keyMappings: { c_visita_id: 12, c_personal_id: 13 }
            , gridColumnsOverrides: GestionReportesViewColumnsOverrides
            , FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new DatosServiciosAutorizacionReportesFilters(client, parentKeys)
        },
        dasa_brwGestionReportesVisitasIniciadasAppSupervisor: {
            name: 'dasa_brwGestionReportesVisitasIniciadasAppSupervisor'
            , keyMappings: { c_visita_id: 12, c_personal_id: 13 }
            , gridColumnsOverrides: GestionReportesViewColumnsOverrides
            , FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new DatosServiciosAutorizacionReportesAppSupervisorFilters(client, parentKeys)
        },
        dasa_brwGestionReportesVisitasEnProcesoAppSupervisor: {
            name: 'dasa_brwGestionReportesVisitasEnProcesoAppSupervisor'
            , keyMappings: { c_visita_id: 12, c_personal_id: 13 }
            , gridColumnsOverrides: GestionReportesViewColumnsOverrides
            , FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new DatosServiciosAutorizacionReportesAppSupervisorFilters(client, parentKeys)
        },
        dasa_brwGestionReportesVisitasFinalizadasAppSupervisor: {
            name: 'dasa_brwGestionReportesVisitasFinalizadasAppSupervisor'
            , keyMappings: { c_visita_id: 12, c_personal_id: 13 }
            , gridColumnsOverrides: GestionReportesViewColumnsOverrides
            , FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new DatosServiciosAutorizacionReportesAppSupervisorFilters(client, parentKeys)
        }
    }
)

const lookups = () =>
(
    {
        'ServiciosConfiguracion': {
            name: 'ServiciosConfiguracion',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new ServiciosConfiguracion(client, parentKeys)
        },

        'Productos': {
            name: 'Productos',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Productos(client, parentKeys)
        },

        'Tiendas': {
            name: 'Tiendas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Tiendas(client, parentKeys)
        },

        'Clientes': {
            name: 'Clientes',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Clientes(client, parentKeys)
        },

        'Personal': {
            name: 'Personal',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personal(client, parentKeys)
        },

        'VisitasATiendas': {
            name: 'VisitasATiendas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new VisitasATiendas(client, parentKeys)
        },

    }
)

const procs = () =>
(
    {
        dasa_AutorizarReporte: { name: 'dasa_AutorizarReporte' }
    }
)

const clientActions = () =>
(
    {
        ACTAutorizarReporte: ACTAutorizarReporte,
        ACTAgregarReporte: ACTAgregarReporte,
        ACTCheckin: ACTCheckin,
        ACTCheckout: ACTCheckout,
        ACTVerUbicacion: ACTVerUbicacion
    }
)

export class DatosServiciosAutorizacionDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();
    procs = procs();
    clientActions = clientActions();

    constructor() {
        super('DatosServiciosAutorizacion');
    }
}